import React from 'react';
import { observer } from 'mobx-react';
import { TemplateStoreProps } from '../../stores/list/TemplateStore';
import { WeaFormItem, WeaTools, WeaDialog, WeaLocaleProvider } from 'ecCom';
import { WeaSwitch } from 'comsMobx';
import { Button } from 'antd';
const getLabel = WeaLocaleProvider.getLabel;

export interface TemplateProps {
    template: TemplateStoreProps;
    params?: any;
}
@observer
export default class Template extends React.Component<TemplateProps, any> {
    render() {
        const { template } = this.props;
        let formParams = template.form.getFormParams();
        return (
            <div>
                {
                    template.fields.map((d,idn) => {
                        let key = WeaTools.getKey(d);
                        let error = template.errors[key];
                        return (<div className="wea-search-group" >
                            <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@1bnz2q@${idn}`}
                                label={d.label}
                                labelCol={{ span: d.labelcol }}
                                wrapperCol={{ span: d.fieldcol }}
                                error={template.form.getError(d)}
                                tipPosition="bottom"
                            >
                                <WeaSwitch ecId={`${this && this.props && this.props.ecId || ''}_WeaSwitch@78qfe7@${idn}`} fieldConfig={d} form={template.form} formParams={formParams} onChange={template.clearError.bind(this, key)} />
                                <div className="form-item-error"
                                    dangerouslySetInnerHTML={{ __html: error && `<span style="color:#f50;"><i class="anticon anticon-cross-circle" ></i>${error}</span>` }} />
                            </WeaFormItem>
                            </div>
                        )
                    })
                }
            </div >
        )
    }
}

@observer
export class TemplateDialog extends React.Component<TemplateProps, any>{
    render() {
        const { template, params } = this.props;
        const {iconInfo} = params;
        const buttons = [<Button ecId={`${this && this.props && this.props.ecId || ''}_Button@epln74@onCancel`} onClick={template.onCancel}>{getLabel(309,"关闭")}</Button>,
        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@8emr1h@onOk`} type="primary" loading={template.loading} onClick={template.onOk.bind(this, params)}>{getLabel(86,'保存')}</Button>]
        return (
            <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@0v9x6l`}
                className='wea-auth-modal cube-dialog'
                buttons={buttons}
                title={getLabel(16388,'新建模板')}
                iconBgcolor={iconInfo.iconBg || "#96358a"}
                icon={iconInfo.icon ||'icon-coms-ModelingEngine'}
                iconFontColor={iconInfo.iconColor || "#fff"}
                visible={template.visible}
                style={{ width: 520, height: 250 }}
                hasScroll={true}
                onCancel={template.onCancel}
            >
                <Template ecId={`${this && this.props && this.props.ecId || ''}_Template@8qpqtw`} template={template} />
            </WeaDialog >
        )
    }
}
export const getTemplate = (template) => {
    return <Template ecId={`${this && this.props && this.props.ecId || ''}_Template@fvxi2b`} template={template} />
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/pages/template/index.tsx